export default class LangStorageManager {
  constructor(lang) {
    this.language = lang;
    if(this.getStorage === null){this.setStorage();}
  }

  setStorage() {
    localStorage.setItem("lang", this.language);
  }

  getStorage() {
    return localStorage.getItem("lang");
  }
}